import { SVG } from '../svg';
import { IconProps } from '../types';

export function TrophyIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props} viewBox="0 0 20 18">
      <path
        d="M10.0001 13.1667C7.00854 13.1667 4.58341 10.7415 4.58341 7.75V2.7963C4.58341 2.36449 4.58341 2.14859 4.66149 1.98115C4.74429 1.80359 4.887 1.66088 5.06457 1.57808C5.232 1.5 5.44791 1.5 5.87971 1.5H14.1205C14.5523 1.5 14.7682 1.5 14.9356 1.57808C15.1132 1.66088 15.2559 1.80359 15.3387 1.98115C15.4167 2.14859 15.4167 2.36449 15.4167 2.7963V7.75C15.4167 10.7415 12.9916 13.1667 10.0001 13.1667ZM10.0001 13.1667V16.5M14.1667 16.5H5.83341M18.3334 3.16667V7.33333M1.66675 3.16667V7.33333"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
}
